import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PERMISSIONS_LOCATION",
    parentId: "SETTINGS_PERMISSIONS",
    applicationRights: Rights,
    title: 'Lokasjonsdeling',
    text: 'Lokasjonsdeling',
    canShowOnDashboard: false,
    url: `/settings/permissions/LOCATION_SHARING`})
